export const ENDPOINTS = {
  getCitiesByCountryAndState: (country, state) =>
    `/api/o/city/grid?country=${country}&state=${state}&rows=-1`,
};
